import React from 'react';
import PropTypes from 'prop-types';
import { Header, Footer, Loader, Menu, BaasicModal } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { selectLogo } from 'core/utils';
import { SubmitTicket } from 'modules/contact/pages';

const MainLayoutTemplate = ({ render, initialized, t, mainViewStore: { isCollapsed, toggleCollapse, submitTicketModal, rootStore }, ...props }) => {
	if (!initialized) return <Loader />;
	var logo_show = selectLogo();
	return (
		<div>
			<div className="layout">
				<div className={`layout__aside ${isCollapsed ? 'is-collapsed' : ''}`}>
					<div className="logo__wrap">
						<div className="logo__wrap--inner">
							<img className="logo__aside" src={logo_show} alt="logo" />
							<img className="logo__aside__symbol" src={logo_show} alt="logo" />
						</div>
					</div>
					<div className="nav__item nav__item--collapse" onClick={toggleCollapse}>
						<i className="fa fa-expand spc--right--sml"></i>
						<span>{t('MENU')}</span>
					</div>
					<Menu />
					<div className="nav__item nav__item--separate" onClick={() => submitTicketModal.open()}>
						<i className="fas fa-question-circle spc--right--sml"></i>
						<span>{t('CONTACT')}</span>
					</div>
					{/* <div className="nav__item nav__item" onClick={() => submitTicketModal.open()}>
						<i className="fas fa-question-circle spc--right--sml"></i>
						<span>{t('DASHBOARD')}</span>
					</div> */}
				</div>

				<main className={`layout__main ${isCollapsed ? 'is-collapsed' : ''}`}>
					<div className="layout__main__body">
						<Header />
						{render(props)}
					</div>

					<div className={`layout__main__footer ${isCollapsed ? 'is-collapsed' : ''}`}>
						<Footer rootStore={rootStore} />
					</div>
				</main>
			</div>
			<BaasicModal modalParams={submitTicketModal} className="ReactModal--lrg">
				<SubmitTicket />
			</BaasicModal>
		</div>
	);
};

MainLayoutTemplate.propTypes = {
	render: PropTypes.func,
};

export default defaultTemplate(MainLayoutTemplate);
